import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  type: "all",
  sortBy: "default",
};

// create slice
const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    changeFilterType: (state, action) => {
      state.type = action.payload;
    },
    changeFilterBySort: (state, action) => {
      state.sortBy = action.payload;
    }

  },
});

export const { changeFilterType, changeFilterBySort } = filterSlice.actions;
export default filterSlice.reducer;
